<template>
  <div class="Brick">

    <div class="row" v-for="row in brick.rows">
      <brick-item :item="item" class="item" v-for="item in row.items">
      </brick-item>
    </div>

    <bingo></bingo>

  </div>
</template>

<script>

import { store } from '@/store';

import BrickItem from '@/components/BrickItem'
import Bingo from '@/components/Bingo'

export default {
  name: 'Brick',
  components: {
    BrickItem,
    Bingo
  },
  data () {
    return {
      bingo: ""
    }
  },
  props: {
    size: {type: Number, default: 5}
  },
  computed: {
    brick: function () {
      return store.state.brick;
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.Brick{
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid gray;
  box-sizing: border-box;
  max-width: 600px;
  position: relative;
}

.row{
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.item{
  border: 1px solid lightgray;
  flex-wrap: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Brick.vue